import { useState } from "react";
import { Link } from "@tanstack/react-router";

import { HelpModal } from "@/domains/profile/components/help-modal";
import { Button, focusRing, IconButton, icons } from "@/ui";
import { isExternalLink } from "@/utils/validation";

type GuestHeaderProps = {
  logoRedirectUrl?: string;
};

export const GuestHeader = ({ logoRedirectUrl = "/" }: GuestHeaderProps) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <HelpModal
        closeModal={() => {
          return setOpenModal(false);
        }}
        isOpen={openModal}
      />

      <header className="flex flex-row items-center justify-between gap-4 border-b border-line bg-surface px-4 py-4 shadow-card md:px-12 md:py-5">
        {isExternalLink(logoRedirectUrl) ? (
          <a
            className={`w-fit rounded-md transition-opacity hover:opacity-80 ${focusRing}`}
            href={logoRedirectUrl}
            rel="noreferrer"
            target="_blank"
          >
            <span className="sr-only">EO Care</span>
            <icons.eoIcon aria-hidden="true" className="text-content" />
          </a>
        ) : (
          <Link
            className={`w-fit rounded-md transition-opacity hover:opacity-80 ${focusRing}`}
            to={logoRedirectUrl}
          >
            <span className="sr-only">EO Care home</span>
            <icons.eoIcon aria-hidden="true" className="text-content" />
          </Link>
        )}

        <div className="hidden flex-row items-center gap-2 lg:flex">
          <Button
            onClick={() => {
              window.open("https://www.eo.care/web/privacy-policy", "_blank");
            }}
            variant="secondary-dark"
          >
            Privacy Policy
          </Button>

          <Button
            onClick={() => {
              return setOpenModal(true);
            }}
            variant="primary"
          >
            Need Help?
          </Button>
        </div>

        <div className="flex flex-row items-center gap-2 lg:hidden">
          <IconButton
            label="Privacy Policy"
            onClick={() => {
              window.open("https://www.eo.care/web/privacy-policy", "_blank");
            }}
          >
            <icons.PrivacyPolicyIcon aria-hidden="true" className="size-7 stroke-2" />
          </IconButton>

          <IconButton
            label="Need help?"
            onClick={() => {
              return setOpenModal(true);
            }}
          >
            <icons.MarkCircleIcon aria-hidden="true" className="size-7" />
          </IconButton>
        </div>
      </header>
    </>
  );
};
